import React, { Fragment } from 'react';
import { timeIsLessThanGap } from '@finect/front-utils/timeIsLessThanGap';
import { getProductPath } from '@finect/front-resources/Products';
import { SocialStatsCount, SocialStatsBlock, SocialStatsCountSpacingReserve } from '../partials';
import { NewsTag } from './partials';
import { Rating } from './../../../Rating';
var DAYS = 5;
export var SocialStats = function SocialStats(_ref) {
  var product = _ref.product,
    _ref$context = _ref.context,
    context = _ref$context === void 0 ? [] : _ref$context,
    _ref$display = _ref.display,
    display = _ref$display === void 0 ? 'flex' : _ref$display,
    _ref$showEmpty = _ref.showEmpty,
    showEmpty = _ref$showEmpty === void 0 ? true : _ref$showEmpty,
    _ref$showNewBadge = _ref.showNewBadge,
    showNewBadge = _ref$showNewBadge === void 0 ? false : _ref$showNewBadge,
    _ref$withRating = _ref.withRating,
    withRating = _ref$withRating === void 0 ? false : _ref$withRating;
  var entity = product.entity;
  var socialStats = entity.socialStats;
  var path = getProductPath(product, context);
  var reviewsPath = "".concat(path, "#opiniones");
  var questionsPath = "".concat(path, "#preguntas");
  var answers = socialStats.answers.total;
  var reviews = socialStats.reviews.total;
  var showAnswers = answers || showEmpty;
  var showReviews = reviews || showEmpty;
  var lastAnswerDate = socialStats.answers && socialStats.answers.last ? socialStats.answers.last.date : null;
  var lastReviewDate = socialStats.reviews && socialStats.reviews.last ? socialStats.reviews.last.date : null;
  var newAnswer = lastAnswerDate && timeIsLessThanGap(DAYS * 24 * 60 * 60, new Date(lastAnswerDate), new Date());
  var newReview = lastReviewDate && timeIsLessThanGap(DAYS * 24 * 60 * 60, new Date(lastReviewDate), new Date());
  var showSocialBadge = showNewBadge && display === 'block';
  return React.createElement(Fragment, null, withRating ? React.createElement(SocialStatsBlock, {
    display: display
  }, React.createElement(Rating, {
    size: "small",
    value: entity.score || 0,
    isSelectable: false,
    starSize: "18",
    type: "infoStar"
  })) : null, React.createElement(SocialStatsBlock, {
    display: display
  }, showReviews ? React.createElement(SocialStatsCount, {
    href: reviewsPath,
    target: "_top"
  }, reviews, " ", reviews === 1 ? 'opinión' : 'opiniones', showSocialBadge && newReview ? React.createElement(NewsTag, null, "nueva") : null) : null, showAnswers ? React.createElement(SocialStatsCount, {
    href: questionsPath,
    target: "_top"
  }, answers, " pregunta", answers === 1 ? '' : 's', showSocialBadge && newAnswer ? React.createElement(NewsTag, null, "nueva") : null) : null, !showEmpty && !showAnswers ? React.createElement(SocialStatsCountSpacingReserve, null) : null));
};